import {
  CustomerRequest,
  CustomerRequestUplaod,
  T_SummaryData,
} from "../features/Feature_Homeloan/Homeloan_Types";
import {
  ABC_SERVICE_APPSTORE_URL,
  ABC_SERVICE_PLAYSTORE_URL,
  Abcd_Super_App_Lob_Id,
  ActiveStatusText,
  Cs_App_Lob_Id,
  DashboardTabKeys,
  dobRegex,
  FooterDetailsList,
  HiDestinationLobId,
  HiLobCode,
  HlLobCode,
  HomeLoansDestinationLobId,
  LiDestinationLobId,
  LiLobCode,
  LoansDestinationLobId,
  MfDestinationLobId,
  MfLobCode,
  ModuleNameKey,
  monthsList,
  myStatementsText,
  panRegex,
  pathToModuleName,
  PersonalLoansLobCode,
  phoneRegex,
  REACT_APP_URL,
  SCREEN_TYPE,
  sfdcBusinessUnit,
  sfdcChannel,
  sfdcIntimationType,
  sfdcPriority,
  sfdcSourceName,
  SsDestinationLobId,
  staticPurchaseCtaFunctionalityCode,
  StockLobCode,
} from "./constants";
import CryptoJS from "crypto-js";
import { SignJWT } from "jose";
import { currencyConvertor, CurrencyFormat } from "./conversionUtils";
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  J_FunctionalityCode,
  UserPayload,
  T_CustomerLobDetails,
  T_LogoutInfoToBePassed,
  T_UserProfile,
  T_BioInfo,
  UserPayloadChatBot,
  T_CsAppSliceState,
} from "../globalTypes/GlobalTypes";
import {
  APi_DownloadPolicyAccountStatement,
  Api_DownloadTaxCertificate,
  Api_FetchPolicyDetailsByMobileNumber,
  Api_GetCustomerLobDetails,
  Api_SendEmail,
  Api_SendWhatsApp,
} from "./ApiEndpoints";
import { InternalAxiosRequestConfig } from "axios";
import { generatePath } from "react-router-dom";
import { PDFDocument } from "pdf-lib";

import {
  T_CustomerLobDetailObj,
  T_GenerateTokenRes,
  T_GetCustomerLobDetailsRes,
} from "../features/Feature_Login/Login_Types";
import _, { isEmpty } from "lodash";
import CsSessionStorageUtils from "./CsSessionStorageUtils";
import { getCookie } from "./CSCookieHandler";
import {
  T_FetchMasterData_Response,
  T_MasterData_DetailObjOption,
  T_menu,
} from "../features/Feature_GeneralAppElements/GeneralAppElements_Types";
import {
  R_HiRoutes,
  R_HLRoutes,
  R_HomeRoutes,
  R_LiRoutes,
  R_MfRoutes,
  R_SSRoutes,
} from "./Routes";
import { T_CmsFetchUnifiedOfferMart } from "../features/Features_Cms/CmsPageVariable.Types";
import { TriggerGenerateSSO_OLD } from "../features/Feature_SSO/Sso_Types";
import {
  T_FetchPremiumReceiptWithDateResponse_Details,
  T_OneServiceSub_Request,
  T_RwsDetails,
} from "../features/Feature_LifeInsurance/LifeInsurance_Types";

import usePromotionalCardsNew from "../hooks/usePromotionalCardsNew";
import { T_CmsIntegrationVariables } from "../features/Features_Cms/CmsIntegrationVariable.Types";
import { triggerCleverTapEvent } from "./CleverTap";
import { T_StockDashboardDetails } from "../features/Feature_StocksAndSecurities/Stockc&Securities_Types";
declare const window: any;
const jwtSecretKey = process.env.REACT_APP_JWT_SECRET_KEY;
const chatbotjwtSecretKey = process.env.REACT_APP_JWT_SECRET_KEY_FOR_CHATBOT;
const secretKey = new TextEncoder().encode(jwtSecretKey);
const chatbotsecretKey = new TextEncoder().encode(chatbotjwtSecretKey);
interface Option {
  label: string;
  value: string;
}

interface UniqueValues {
  yearOptionsList: Option[];
  monthOptionsList: Option[];
}
interface FileObject {
  fileName: string;
  fileExtension: string;
  base64: string;
}
interface NPSItem {
  value?: string;
  mode?: string;
}
export const defaultEmptyFun = () => {
  //This is intentional
};

export const timeDifferenceInDays = (
  initialDate: Date,
  finalDate: Date
): number => {
  const oneDay = 1000 * 60 * 60 * 24; // Number of milliseconds in a day
  const timeDifference = Math.abs(initialDate.getTime() - finalDate.getTime()); // Difference in milliseconds
  return Math.floor(timeDifference / oneDay); // Convert difference to days
};

export const timeDifferenceInHrs = (
  initialDate: Date,
  finalDate: Date
): number => {
  const oneHour = 1000 * 60 * 60; // Number of milliseconds in an hour
  const timeDifference = Math.abs(initialDate.getTime() - finalDate.getTime()); // Difference in milliseconds
  return Math.floor(timeDifference / oneHour); // Convert difference to hours (including decimals)
};

// Utility function to validate PAN
export const isValidPAN = (pan: string = ""): boolean => {
  return panRegex.test(pan);
};
export const isValidMobile = (mobile: string = ""): boolean => {
  return phoneRegex.test(mobile);
};
// Utility function to validate DOB (in "DD Mon YYYY" format)
export const isValidDOB = (dob: string): boolean => {
  return dobRegex.test(dob);
};

export const fetchPolicyTermsDescriptionByTitle = (
  inputTitle: string
): string => {
  switch (inputTitle) {
    case FooterDetailsList.termsAndConditions.title: {
      return FooterDetailsList.termsAndConditions.description;
    }
    case FooterDetailsList.privacyPolicy.title: {
      return FooterDetailsList.privacyPolicy.description;
    }
    case FooterDetailsList.aboutUs.title: {
      return FooterDetailsList.aboutUs.description;
    }
    default: {
      return "";
    }
  }
};

export const encryptString = (payload: any, IV: string, secretKey: string) => {
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const salt = CryptoJS.enc.Utf8.parse(IV);
  return CryptoJS.AES.encrypt(payload, key, {
    iv: salt,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
};

export const decryptString = (
  data: string | null,
  IV: string,
  secretKey: string
) => {
  if (!data) {
    return "";
  }
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const salt = CryptoJS.enc.Utf8.parse(IV);
  const decrypted = CryptoJS.AES.decrypt(data, key, {
    iv: salt,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

interface Option {
  label: string;
  value: string;
  isCustom?: boolean;
}

export const getFinancialYearOptions = ({ isCustom = false }): Option[] => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const currentFYStartYear = currentMonth >= 4 ? currentYear : currentYear - 1;
  const currentFYEndYear = currentFYStartYear + 1;
  const previousFYStartYear = currentFYStartYear - 1;
  const previousFYEndYear = currentFYStartYear;
  if (isCustom) {
    return [
      {
        label: `FY ${currentFYStartYear}-${currentFYEndYear
          .toString()
          .slice(2)}`,
        value: `FY ${currentFYStartYear}-${currentFYEndYear
          .toString()
          .slice(2)}`,
      },
      {
        label: `FY ${previousFYStartYear}-${previousFYEndYear
          .toString()
          .slice(2)}`,
        value: `FY ${previousFYStartYear}-${previousFYEndYear
          .toString()
          .slice(2)}`,
      },
      {
        label: `Custom`,
        value: `Custom`,
      },
    ];
  } else {
    return [
      {
        label: `FY ${currentFYStartYear}-${currentFYEndYear
          .toString()
          .slice(2)}`,
        value: `FY ${currentFYStartYear}-${currentFYEndYear
          .toString()
          .slice(2)}`,
      },
      {
        label: `FY ${previousFYStartYear}-${previousFYEndYear
          .toString()
          .slice(2)}`,
        value: `FY ${previousFYStartYear}-${previousFYEndYear
          .toString()
          .slice(2)}`,
      },
    ];
  }
};

// Utility function to convert financial year to start and end dates
// export const getFinancialYearDates = (
//   financialYear: string,
//   isPolicyStatement: boolean
// ) => {
//   const [startYear, endYear] = financialYear
//     .split("FY ")[1]
//     .split("-")
//     .map(Number);
//   const startDate = isPolicyStatement
//     ? `01-04-${startYear}`
//     : `01/04/${startYear}`;
//   const endDate = isPolicyStatement
//     ? `31-03-${2000 + endYear}`
//     : `31/03/${2000 + endYear}`;
//   return { startDate, endDate };
// };

export const getFinancialYearDates = (
  financialYear: string,
  isPolicyStatement: boolean
) => {
  const today = dayjs();
  const currentFinancialYear = getCurrentFinancialYear();

  const [startYear, endYear] = financialYear
    .split("FY ")[1]
    .split("-")
    .map(Number);

  const isCurrentFinancialYear = financialYear === currentFinancialYear;
  let formatType = isPolicyStatement ? "DD-MM-YYYY" : "DD/MM/YYYY";
  const startDate = dayjs(`${startYear}-04-01`).format(formatType);
  const endDate = isCurrentFinancialYear
    ? today.format(formatType)
    : dayjs(`${endYear + 2000}-03-31`).format(formatType);
  return { startDate, endDate };
};

export const getFinancialYearDatesForFullYear = (
  financialYear: string,
  isPolicyStatement: boolean
) => {
  const currentYear = dayjs().year();
  const currentDate = new Date();
  const [startYear, endYear] = financialYear.split("-").map(Number);
  const startDate = `${startYear}-04-01`;
  const endDate =
    endYear > currentYear
      ? currentDate.toLocaleDateString("en-CA")
      : `${endYear}-03-31`;
  return { startDate, endDate };
};

export const getLastTwoFinancialYears = () => {
  const currentYear = dayjs().year();
  let startDate = `01/04/${currentYear - 2}`;
  let endDate = dayjs().format("DD/MM/YYYY");
  // Calculate last two financial years
  return {
    startDate,
    endDate,
  };
};

// export const downloadPdfFromBase64 = async (
//   pdfData: string = "",
//   fileName: string = "file.pdf"
// ) => {

//   const byteCharacters = atob(pdfData);
//   const byteNumbers = new Array(byteCharacters.length);
//   for (let i = 0; i < byteCharacters.length; i++) {
//     byteNumbers[i] = byteCharacters.charCodeAt(i);
//   }
//   const byteArray = new Uint8Array(byteNumbers);
//   const blob = new Blob([byteArray], { type: "application/pdf" })
//     const blobUrl = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = blobUrl;
//     link.download = fileName;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     URL.revokeObjectURL(blobUrl);

// };

export const downloadZIPFromBase64 = async (
  zipData: string = "",
  fileName: string = "file.zip"
) => {
  const binaryData = atob(zipData);
  const byteArray = new Uint8Array(binaryData.length);
  for (let i = 0; i < binaryData.length; i++) {
    byteArray[i] = binaryData.charCodeAt(i);
  }
  const blob = new Blob([byteArray], { type: "application/zip" });

  if (getMobileOperatingSystem() === "iOS") {
    const reader = new FileReader();
    reader.onloadend = () => {
      const link = document.createElement("a");
      link.href = reader.result as string;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    reader.readAsDataURL(blob);
  } else {
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  }
};
export const extractPremiumReceiptValues = (
  dataArray: T_FetchPremiumReceiptWithDateResponse_Details[]
): UniqueValues => {
  const yearsMap: { [key: string]: boolean } = {};
  const monthsMap: { [key: string]: boolean } = {};
  const monthNames: string[] = monthsList;
  const yearOptionsList: Option[] = [];
  const monthOptionsList: Option[] = [];

  if (dataArray && dataArray.length) {
    dataArray.forEach((item) => {
      const dateParts = item.PROCESSDATE.split("/");
      const monthIndex = parseInt(dateParts[1], 10) - 1;
      const monthValue = monthNames[monthIndex];
      const yearValue = dateParts[2].substring(0, 4);
      if (!yearsMap[yearValue]) {
        yearOptionsList.push({ label: yearValue, value: yearValue });
        yearsMap[yearValue] = true;
      }
      if (!monthsMap[monthValue]) {
        monthOptionsList.push({ label: monthValue, value: monthValue });
        monthsMap[monthValue] = true;
      }
    });
    return { yearOptionsList, monthOptionsList };
  } else {
    return { yearOptionsList, monthOptionsList };
  }
};

export function extractReceiptDateAmount(
  selectedYear: string,
  selectedMonth: string,
  dataArray: T_FetchPremiumReceiptWithDateResponse_Details[]
) {
  const year = parseInt(selectedYear.trim());
  const month = selectedMonth.trim();
  // Initialize arrays for day and amount
  let filteredReceiptDate: Option[] = [];
  // let filteredReceiptAmount: Option[] = [];
  let finalFilteredReceiptDate: Option[] = [];
  // Iterate through dataArray
  dataArray.forEach((item) => {
    // Split the date string into components
    const parts = item.PROCESSDATE.split(/[\/ :]/);
    // Parse components into integers
    const day = parseInt(parts[0], 10);
    const monthIndex = parseInt(parts[1], 10) - 1; // Month is zero-indexed
    const yearValue = parseInt(parts[2], 10);
    const hour = parseInt(parts[3], 10);
    const minute = parseInt(parts[4], 10);
    const second = parseInt(parts[5], 10);
    // Create a new Date object using parsed components
    const processDate = new Date(
      yearValue,
      monthIndex,
      day,
      hour,
      minute,
      second
    );
    // Check if item matches year and month
    if (
      processDate.getFullYear() === year &&
      getMonthName(processDate.getMonth() + 1) === month
    ) {
      // Format day as "Day Month"
      const formattedDay = `${processDate.getDate()} ${processDate.toLocaleString(
        "en-US",
        { month: "long" }
      )}`;

      // Push to dayArray and amountArray
      filteredReceiptDate.push({
        label: formattedDay,
        value: formattedDay,
      });
      const uniqueSet = new Set();

      // Filter out duplicates based on 'label' and 'value'
      finalFilteredReceiptDate = filteredReceiptDate.filter((obj) => {
        const key = `${obj.label}_${obj.value}`;
        if (!uniqueSet.has(key)) {
          uniqueSet.add(key);
          return true;
        }
        return false;
      });

      // filteredReceiptAmount.push({
      //   label: currencyConvertor(item.RCPTAMOUNT.toFixed(2).toString()),
      //   value: currencyConvertor(item.RCPTAMOUNT.toFixed(2).toString()),
      // });
    }
  });
  return { finalFilteredReceiptDate };
}

export function extractReceiptAmountByDate(
  receiptDate: string,
  dataArray: { PROCESSDATE: string; RCPTAMOUNT: number }[] // Adjusted to match provided data structure
) {
  let filteredReceiptAmount: Option[] = [];
  const seenAmounts = new Set<string>(); // To track unique amounts

  // Iterate through dataArray
  dataArray.forEach((item) => {
    // Extract date from PROCESSDATE (first part before the space)
    const datePart = item.PROCESSDATE.split(" ")[0]; // "07/11/2024"
    const parts = datePart.split("/"); // ["07", "11", "2024"]
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);

    // Format day as "Day Month"
    const formattedDay = `${day} ${getMonthName(month)}`;

    // Check if formattedDay matches receiptDate
    if (formattedDay === receiptDate) {
      const formattedAmount = CurrencyFormat(item.RCPTAMOUNT.toString());

      // If the amount is not already in the set, add it to the results
      if (!seenAmounts.has(formattedAmount)) {
        filteredReceiptAmount.push({
          label: formattedAmount,
          value: formattedAmount,
        });
        seenAmounts.add(formattedAmount); // Mark the amount as seen
      }
    }
  });

  return filteredReceiptAmount;
}

// Function to get month name from month number, used in extractReceiptAmountByDate,extractReceiptDateAmount,extractPremiumReceiptValues
function getMonthName(monthNumber: number) {
  const months = monthsList;
  return months[monthNumber - 1]; // Month array is 0-indexed
}

export function extractDownloadablePremiumReceipt(
  year: string,
  month: string,
  date: string,
  amount: string,
  dataArray: T_FetchPremiumReceiptWithDateResponse_Details[]
) {
  const monthLower = month.toLowerCase();
  const targetDate = new Date(`${year}-${monthLower}-${date}`);

  return dataArray.filter((item) => {
    const processDate = new Date(
      item.PROCESSDATE.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1")
    );

    return (
      processDate.getFullYear() === targetDate.getFullYear() &&
      processDate.getMonth() === targetDate.getMonth() &&
      processDate.getDate() === targetDate.getDate()
    );
  });
}

export const getFileSize = (file: File) => {
  const fileSizeInBytes = file.size;
  const fileSizeInKB = fileSizeInBytes / 1024; // Convert bytes to KB
  const fileSizeInMB = fileSizeInKB / 1024; // Convert KB to MB
  let sizeToShow;
  if (fileSizeInMB >= 1) {
    sizeToShow = `${fileSizeInMB.toFixed(2)}mb`;
  } else {
    sizeToShow = `${fileSizeInKB.toFixed(2)}kb`;
  }
  return sizeToShow;
};

const parseDate = (dateString: string) => dayjs(dateString, "DD/MM/YYYY");

export const getLatestDateData = (data: T_RwsDetails[]) => {
  if (data.length > 0) {
    return data.reduce(
      (maxObject: T_RwsDetails, currentObject: T_RwsDetails) => {
        const maxDate = maxObject ? parseDate(maxObject.process_date) : null;
        const currentDate = parseDate(currentObject.process_date);
        if (!maxDate || currentDate.isAfter(maxDate)) {
          return currentObject;
        } else {
          return maxObject;
        }
      }
    );
  } else {
    return undefined;
  }
};

export const getInitials = (name: string = "") => {
  if (name) {
    const parts = name.split(" ");
    let initials = [""];
    if (parts?.length > 1) {
      initials = [parts[0]?.charAt(0), parts[parts.length - 1]?.charAt(0)];
    } else {
      initials = [parts[0]?.charAt(0)];
    }
    return initials.join("").toUpperCase(); // Convert to uppercase if needed
  }
};

export const propagateEvent = (eventName: string, data: any) => {
  console.log("Event", eventName, "\nData", data);
  // @ts-ignore: Window should have flutter_inappwebview variable
  window?.flutter_inappwebview?.callHandler(eventName, data);
};

export const getMaskedMobileNumber = (
  mobileNumber: string = "",
  symbol: string = "X"
) => {
  if (mobileNumber.length === 13) {
    return mobileNumber.slice(0, 5) + symbol.repeat(6) + mobileNumber.slice(-2);
  }
  if (mobileNumber) {
    return mobileNumber.slice(0, 2) + symbol.repeat(6) + mobileNumber.slice(-2);
  }
  return "";
};

export const getMaskedEmail = (email: string) => {
  const [localPart, domain] = email.toLowerCase().split("@");

  if (!domain) return email; // In case of invalid email format

  const [domainName, domainExt] = domain.split(".");

  const maskedLocalPart =
    localPart.length > 2
      ? `${localPart.slice(0, 2)}${"x".repeat(localPart.length - 2)}`
      : localPart;

  const maskedDomainName =
    domainName.length > 2
      ? `${domainName.slice(0, 2)}${"x".repeat(domainName.length - 2)}`
      : domainName;

  const maskedDomainExt = "x".repeat(domainExt.length);

  return `${maskedLocalPart}@${maskedDomainName}.${maskedDomainExt}`;
};

export const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z.-]+\.[a-zA-Z]{2,}$/;
// /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidateEmail = (email: string): boolean => {
  return emailRegex.test(email);
};

export const getRouteFromFuncCode = (
  functionalityCode: string,
  fallbackIfNotFound = true,
  fallbackRoute: string = R_HomeRoutes.home
) => {
  return J_FunctionalityCode.find((f) => f.funcCode === functionalityCode)
    ?.route || fallbackIfNotFound
    ? fallbackRoute
    : undefined;
};

export const getStaticReqPayload = (config: InternalAxiosRequestConfig) => {
  switch (config?.url || "") {
    case Api_GetCustomerLobDetails:
      return { mobile: "9228417017" }; // 9437473531
    case Api_FetchPolicyDetailsByMobileNumber:
      return { mobileNumber: "9730896906" }; //"8903263193"
    case Api_DownloadTaxCertificate:
      return {
        ...config.data,
        policyId: "007255785",
        startDate: "01/04/2020",
        endDate: "17/02/2022",
      };
    case APi_DownloadPolicyAccountStatement:
      return {
        ...config.data,
        policyId: "001572067",
        startDate: "13-05-2019",
        endDate: "25-05-2019",
      };
    case Api_SendEmail:
    case Api_SendWhatsApp:
      return {
        ...config.data,
        policyNo: "007255785",
        fromDate: "01/04/2020",
        toDate: "17/02/2022",
      };
    default:
      return config.data;
  }
};

export const getValueOfRenewalPayment = (data: string = "") => {
  if (data) {
    return data.substring(1, data.indexOf(","));
  }
  return "";
};

export const getCurrentDateTimeStamp = () => {
  // < dd/MM/yyyy HH:MM:SS PM>
  return new Date().toLocaleString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

export const isPositiveNumber = (str: any) => {
  // Check if the string is not empty and contains numeric data
  const num = parseFloat(str);
  if (!isNaN(num) && num > 0) {
    return true;
  }
  return false;
};

export const isZeroString = (value: string): boolean =>
  !isNaN(parseFloat(value.trim())) && parseFloat(value.trim()) === 0;
export const downloadExcelFromBase64 = async (
  excelData: string = "",
  fileName: string = "file.xlsx"
) => {
  // Decode base64 data to byte array
  const byteCharacters = atob(excelData);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Create a Blob from the byte array with MIME type for Excel (.xlsx)
  const blob = new Blob([byteArray], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Create object URL for the Blob
  const blobUrl = URL.createObjectURL(blob);

  // Create a link element to trigger the download
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName;

  // Append link to the body, click it, and then remove it
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the object URL after the download
  URL.revokeObjectURL(blobUrl);
};

export const injectDynamicValueInFuncnalityCodeUrls = (
  urlSearchParam: URLSearchParams | undefined,
  functionalityCode: string | undefined = "D"
) => {
  const routeDetails = J_FunctionalityCode.find(
    (f) => f.funcCode === functionalityCode
  );
  let injectDataInDynamicPath = routeDetails?.route;
  if (routeDetails?.isDynamicPath) {
    routeDetails.dynamicKeys.forEach((dynamicKey) => {
      const paramValue = urlSearchParam?.get(dynamicKey) || null;
      if (paramValue == null) {
        return R_HomeRoutes.home;
      }
      injectDataInDynamicPath = generatePath(routeDetails.route, {
        [dynamicKey]: paramValue,
      });
    });
  }
  return injectDataInDynamicPath;
};

export const injectDynamicValueInFuncnalityCodeUrls_ssoRedirect = (
  responseDataList: Map<string, string>,
  functionalityCode: string | undefined = "D"
) => {
  const routeDetails = J_FunctionalityCode.find(
    (f) => f.funcCode === functionalityCode
  );
  let injectDataInDynamicPath = routeDetails?.route;
  if (routeDetails?.isDynamicPath) {
    routeDetails.dynamicKeys.forEach((dynamicKey) => {
      const paramValue = responseDataList?.get(dynamicKey) || null;
      if (paramValue == null) {
        return R_HomeRoutes.home;
      }
      injectDataInDynamicPath = generatePath(routeDetails.route, {
        [dynamicKey]: paramValue,
      });
    });
  }
  return injectDataInDynamicPath;
};

export const filterMonthsByYear = (
  data: T_FetchPremiumReceiptWithDateResponse_Details[],
  year: string
) => {
  // Create a Set to store unique months
  const uniqueMonths = new Set();

  // Filter data based on the provided year and collect unique months
  data.forEach((obj) => {
    const processDate = obj.PROCESSDATE;
    const parts = processDate.split("/");
    const objYear = parts[2].substring(0, 4); // Extract year from PROCESSDATE as string
    const objMonth = parseInt(parts[1], 10); // Extract month from PROCESSDATE

    if (objYear === year) {
      uniqueMonths.add(objMonth);
    }
  });

  // Convert month numbers to month names and create label-value pairs
  const monthNames = Array.from(uniqueMonths).map((month) => {
    const monthName = new Date(
      Number(year),
      Number(month) - 1,
      1
    ).toLocaleString("en-US", {
      month: "long",
    });
    return { label: monthName, value: monthName };
  });

  return { monthNames };
};

export const getCaseCreateReqPayload = (
  data: Object,
  endorsementDetailData: Object,
  isNSTPCase?: boolean
) => {
  let EndorsementDetails = {
    AadharCardNo: null,
    AlternateContactNumber: null,
    AlternateEmail: null,
    Country: null,
    Email: null,
    InternationalAddress: null,
    InternationalContactNumber: null,
    MemberAlternateContactNumber: null,
    MemberAlternateEmail: null,
    MemberEmail: null,
    MemberPrimaryContactNumber: null,
    NomineeContact: null,
    NomineeName: null,
    NomineeRelationship: null,
    PED: null,
    PanCardNo: null,
    PrimaryContactNumber: null,
  };
  let details = {
    ActivityDescription: null,
    ActivitySubject: null,
    AssignedTeam: "Endorsement- Non financial",
    AssignedUser: null,
    AttachmentContent: null,
    AttachmentType: null,
    AttachmentName: null,
    BankAccountNumber: null,
    BrokerCode: null,
    CaseId: null,
    CaseSubSubType: null,
    CaseSubType: "Endorsement",
    CaseSubTypeCode: null,
    CaseTitle: null,
    CaseType: "Endorsement",
    Category: "Request",
    Comments: null,
    CreatedOn: null,
    Customer: "",
    CustomerID: "",
    CustomerType: "",
    EmailAddress: null,
    EndorsementDetails: EndorsementDetails,
    IsClosed: "No",
    Mobile: null,
    ModifiedOn: null,
    NotesDescription: null,
    NotesTitle: null,
    OneABCCustomerTAT: null,
    OneABCOwner: null,
    OneABCSubSource: null,
    Origin: isNSTPCase ? "ABC_Servicing_App1" : "ABC_Servicing_App",
    Partner: null,
    PartnerCaseId: null,
    PartnerStatus: null,
    PartnerSubStatus: null,
    Policy: null,
    PolicyStatus: null,
    Priority: null,
    Product: null,
    RedFlag: null,
    Status: null,
    URL: null,
    FunctionalityCode: null,
  };
  let v1 = Object.assign(details, data);
  let v2 = Object.assign(EndorsementDetails, endorsementDetailData);
  v1["EndorsementDetails"] = v2;
  return v1;
};
export const getFinancialYearOptionForCapitalGain = (
  count: number,
  isAccountStatement: boolean = false
) => {
  const today = dayjs();
  const currentMonth = today.month(); // January is 0, February is 1, etc.
  const currentYear = today.year();

  // Determine the start of the current financial year
  let startYear = currentYear;
  let endYear = currentYear + 1;

  // Adjust the start year if the current month is before April
  if (currentMonth < 3) {
    // Months are zero-indexed: 3 is April
    startYear -= 1;
    endYear -= 1;
  }
  const financialYears = [];
  // Generate the past T-3 financial years
  for (let i = 0; i < count; i++) {
    const fyStart = startYear - i;
    const fyEnd = fyStart + 1;
    const fyLabel = `FY ${String(fyStart).slice(
      isAccountStatement ? 0 : -2
    )}-${String(fyEnd).slice(-2)}`;
    financialYears.push({ label: fyLabel, value: fyLabel });
  }
  financialYears.push({
    label: "All Financial Years",
    value: "All Financial Years",
  });
  return financialYears;
};

const parseFinancialYear = (fy: string) => {
  const yearMatch = fy.match(/^FY (\d{2})-(\d{2})$/);
  if (yearMatch) {
    const startYear = `20${yearMatch[1]}`;
    const endYear = `20${yearMatch[2]}`;
    return { startYear, endYear };
  }
  return { startYear: "", endYear: "" };
};

// export const validateDate = (date: string ) => {
//   var disbursedDate = new Date(date);
//   var currentDate = new Date();
//   currentDate.setMonth(currentDate.getMonth() - 6);

//   if (disbursedDate >= currentDate) {
//      return true;
//   } else {
//      return false;
//   }
// }

export const validateDate = (date: string) => {
  // Split the date string (assuming it's in DD/MM/YYYY format)
  const dateParts = date.split("/");
  const formattedDate = new Date(
    `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
  );

  // Get the current date and set it to 6 months ago
  const currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() - 6);

  // Check if the disbursed date is within the last 6 months
  if (formattedDate >= currentDate) {
    return true;
  } else {
    return false;
  }
};

// Calculate the start and end dates for the given financial year
export const getFinancialYearDatesForCapitalGain = (fy: string) => {
  const { startYear, endYear } = parseFinancialYear(fy);
  const today = dayjs();
  if (startYear && endYear) {
    const startDate = dayjs(`${startYear}-04-01`);
    let endDate = dayjs(`${endYear}-03-31`);
    // Adjust endDate if the financial year is the current one
    if (
      (today.isSame(startDate, "day") || today.isAfter(startDate, "day")) &&
      today.isBefore(endDate, "day")
    ) {
      endDate = today;
    }
    return {
      startDate: startDate.format("DD-MM-YYYY"),
      endDate: endDate.format("DD-MM-YYYY"),
    };
  }
  return { startDate: "", endDate: "" };
};
export const getPreviousFinancialYear = (yearsAgo: number) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const startYear = currentMonth >= 3 ? currentYear : currentYear - 1;
  const startPreviousYear = startYear - yearsAgo;
  const endPreviousYear = startPreviousYear + 1;
  return `FY ${startPreviousYear}-${String(endPreviousYear).slice(-2)}`;
};

export const getCurrentFinancialYear = (isHomeLoan?: boolean): string => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const startYear = currentMonth >= 3 ? currentYear : currentYear - 1;
  const endYear = startYear + 1;
  return isHomeLoan
    ? `${startYear}-${endYear}`
    : `FY ${startYear}-${String(endYear).slice(-2)}`;
};

export const formatDate = (dateStr: string): string => {
  let dateObj = new Date(dateStr);

  const monthNames: string[] = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  let day: number = dateObj.getDate();
  let month: string = monthNames[dateObj.getMonth()];
  let year: string = dateObj.getFullYear().toString().slice(-2);

  let daySuffix: string;
  if (day > 3 && day < 21) {
    daySuffix = "th";
  } else {
    switch (day % 10) {
      case 1:
        daySuffix = "st";
        break;
      case 2:
        daySuffix = "nd";
        break;
      case 3:
        daySuffix = "rd";
        break;
      default:
        daySuffix = "th";
    }
  }
  // Extract and format time components
  let hours: number = dateObj.getHours();
  let minutes: number = dateObj.getMinutes();
  let ampm: string = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours || 12; // The hour '0' should be '12'
  let formattedMinutes: string =
    minutes < 10 ? "0" + minutes : minutes.toString();

  let time: string = `${hours}:${formattedMinutes} ${ampm}`;

  return `${day}${daySuffix} ${month}, ${year} | ${time}`;
};

export const getBase64 = async (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result?.toString().split(",")[1]);
    };
    reader.onerror = reject;
  });
};

export const getAttachment = async (file: any) => {
  const bae64StringFromFile = await getBase64(file);
  return {
    attachmentContent: bae64StringFromFile || "",
    attachmentType: getFileExtension(file?.name),
    attachmentName: file.name,
  };
};

export const getCustomerRequest = (
  changeData: Object,
  summaryData: T_SummaryData,
  option: string,
  FunctionalityCode: string
) => {
  const customerRequest: CustomerRequest = {
    FunctionalityCode: FunctionalityCode,
    customerId: summaryData.account_detail.rows[0].CUSTOMER_NO,
    accountNumber: summaryData?.Benificiary_Details?.rows[0]?.LOAN_ACCOUNT_NO,
    firstName: summaryData.account_detail.rows[0].FNAME,
    lastName: summaryData.account_detail.rows[0].LNAME,
    mobile: summaryData.borrower_detail.rows[0].MOBILE,
    emailId: summaryData.borrower_detail.rows[0].E_MAIL,
    subject: "",
    source: "ABC_Servicing_App",
    comments: "",
    subtype: "RSTAWEITHFC",
    isClosed: true,
    url: "",
    category: "Request",
    lob: "HFC",
    priority: "Low",
    segment: "Finance",
    callbackDate: "",
    callbackTimeSlot: "",
    stpsRequestType: option,
    asOnDate: "",
    salaryCreditDate: "",
    dueDate: "",
    changeInEmiAmount: "",
    payableCharge: "",
    partPaymentAmount: "",
    impact: "",
    modeOfRepayment: "",
    soaFromDate: "",
    soaToDate: "",
    icFromYear: "",
    icToYear: "",
    attachments: [
      {
        attachmentName: "",
        attachmentType: "",
        attachmentContent: "",
        comments: "",
      },
    ],
  };
  return Object.assign(customerRequest, changeData);
};

export const getCustomerRequestForRepayment = (
  changeData: Object,
  summaryData: T_SummaryData,
  option: string,
  FunctionalityCode: string
) => {
  const attachments = [
    {
      attachmentName: "",
      attachmentType: "",
      attachmentContent: "",
      comments: "",
    },
  ];
  const customerRequest: CustomerRequest = {
    FunctionalityCode: FunctionalityCode,
    customerId: summaryData.account_detail.rows[0].CUSTOMER_NO,
    accountNumber: summaryData?.Benificiary_Details?.rows[0]?.LOAN_ACCOUNT_NO,
    firstName: summaryData.account_detail.rows[0].FNAME,
    lastName: summaryData.account_detail.rows[0].LNAME,
    mobile: summaryData.borrower_detail.rows[0].MOBILE,
    emailId: summaryData.borrower_detail.rows[0].E_MAIL,
    subject: "Amortization schedule",
    source: "ABC_Servicing_App",
    comments:
      "What is the difference between Semi-Fixed & Floating Rate of Interest?",
    subtype: "hfl004",
    isClosed: true,
    url: "",
    category: "Request",
    lob: "HFC",
    priority: "LOW",
    segment: "Finance",
    callbackDate: "",
    callbackTimeSlot: "",
    stpsRequestType: option,
    asOnDate: "",
    salaryCreditDate: "",
    dueDate: "",
    changeInEmiAmount: "",
    payableCharge: "",
    partPaymentAmount: "",
    impact: "",
    modeOfRepayment: "",
    soaFromDate: "",
    soaToDate: "",
    icFromYear: "",
    icToYear: "",
    attachments: attachments,
  };
  return Object.assign(customerRequest, changeData);
};
export const getCustomerRequestForDocumentUpload = (
  changeData: Object,
  summaryData: T_SummaryData,
  fileObjects: Array<FileObject>,
  // fileName: string,
  // fileExtension: string,
  // base64: string
  FunctionalityCode: string
) => {
  const attachments = fileObjects.map((fileObject) => ({
    attachmentName: fileObject.fileName,
    attachmentType: fileObject.fileExtension,
    attachmentContent: fileObject.base64,
    comments: "no comment",
  }));
  const customerRequest: CustomerRequestUplaod = {
    FunctionalityCode: FunctionalityCode,
    customerId: summaryData.account_detail.rows[0].CUSTOMER_NO,
    accountNumber: summaryData?.Benificiary_Details?.rows[0]?.LOAN_ACCOUNT_NO,
    firstName: summaryData.account_detail.rows[0].FNAME,
    lastName: summaryData.account_detail.rows[0].LNAME,
    mobile: summaryData.borrower_detail.rows[0].MOBILE,
    emailId: summaryData.borrower_detail.rows[0].E_MAIL,
    subject: "Account related-SwapMandate",
    source: "ABC_Servicing_App",
    comments: "",
    subtype: "RREPSWNTHFC",
    isClosed: false,
    url: "",
    category: "Request",
    lob: "HFC",
    priority: "LOW",
    segment: "Finance",
    callbackDate: "",
    callbackTimeSlot: "",
    stpsRequestType: "",
    asOnDate: "",
    salaryCreditDate: "",
    dueDate: "",
    changeInEmiAmount: "",
    payableCharge: "",
    partPaymentAmount: "",
    impact: "",
    modeOfRepayment: "",
    soaFromDate: "",
    soaToDate: "",
    icFromYear: "",
    icToYear: "",
    attachments: attachments,
  };
  return Object.assign(customerRequest, changeData);
};

export const getCustomerRequestForTdsDocumentUpload = (
  changeData: Object,
  summaryData: T_SummaryData,
  fileObjects: Array<FileObject>
  // fileName: string,
  // fileExtension: string,
  // base64: string
) => {
  const attachments = fileObjects.map((fileObject) => ({
    attachmentName: fileObject.fileName,
    attachmentType: fileObject.fileExtension,
    attachmentContent: fileObject.base64,
    comments: "",
  }));
  const customerRequest: CustomerRequestUplaod = {
    FunctionalityCode: "",
    customerId: summaryData.account_detail.rows[0].CUSTOMER_NO,
    accountNumber: summaryData?.Benificiary_Details?.rows[0]?.LOAN_ACCOUNT_NO,
    firstName: summaryData.account_detail.rows[0].FNAME,
    lastName: summaryData.account_detail.rows[0].LNAME,
    mobile: summaryData.borrower_detail.rows[0].MOBILE,
    emailId: summaryData.borrower_detail.rows[0].E_MAIL,
    subject: "TDS refund",
    source: "ABC_Servicing_App",
    comments: "",
    subtype: "hfl074",
    isClosed: false,
    url: "",
    category: "Request",
    lob: "HFC",
    priority: "LOW",
    segment: "Finance",
    callbackDate: "",
    callbackTimeSlot: "",
    stpsRequestType: "",
    asOnDate: "",
    salaryCreditDate: "",
    dueDate: "",
    changeInEmiAmount: "",
    payableCharge: "",
    partPaymentAmount: "",
    impact: "",
    modeOfRepayment: "",
    soaFromDate: "",
    soaToDate: "",
    icFromYear: "",
    icToYear: "",
    attachments: attachments,
  };
  return Object.assign(customerRequest, changeData);
};

export const getReportingServiceRequest = (
  changeData: Object,
  summaryData: T_SummaryData,
  caseId: string
) => {
  const reportingRequest = {
    caseId: caseId,
    source: "CRM",
    requestType: "View",
    lan: summaryData.Benificiary_Details.rows[0].LOAN_ACCOUNT_NO,
    reportName: "BKL",
    documentType: "BinaryData",
    asOnDate: "",
    fromDate: "",
    toDate: "",
  };

  return Object.assign(reportingRequest, changeData);
};

export const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  const bytes = new Uint8Array(buffer);
  let binaryString = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binaryString += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binaryString);
};

const base64ToUint8Array = (base64: string) => {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

const uint8ArrayToBase64 = (uint8Array: Uint8Array): string => {
  const binaryString = Array.from(uint8Array)
    .map((byte) => String.fromCharCode(byte))
    .join("");
  return window.btoa(binaryString);
};

const convertImageToPdf = async (
  imageBase64: string,
  isJpg: boolean = false
): Promise<Uint8Array> => {
  const pdfDoc = await PDFDocument.create();
  const imageBytes = base64ToUint8Array(imageBase64);
  let image;
  if (isJpg) {
    image = await pdfDoc.embedJpg(imageBytes); // Use embedJpg for JPEG images
  } else {
    image = await pdfDoc.embedPng(imageBytes); // Use embedPng for PNG images
  }
  const { width, height } = image.scale(1); // Scaling to keep original size
  const page = pdfDoc.addPage([width, height]);
  page.drawImage(image, {
    x: 0,
    y: 0,
    width: width,
    height: height,
  });

  return pdfDoc.save();
};

export const mergePdfs = async (
  pdfBase64: string,
  otherBase64: string,
  isJpg: boolean = false
): Promise<string> => {
  try {
    let pdfDoc1;
    if (pdfBase64) {
      pdfDoc1 = await PDFDocument.load(base64ToUint8Array(pdfBase64));
    }

    let pdfDoc2;
    // Check if the other file is a PDF or an image
    try {
      pdfDoc2 = await PDFDocument.load(base64ToUint8Array(otherBase64));
    } catch (e) {
      // If it's not a PDF, assume it's an image and convert it
      const imagePdfBytes = await convertImageToPdf(otherBase64, isJpg);
      pdfDoc2 = await PDFDocument.load(imagePdfBytes);
    }

    // Create a new PDF document
    const mergedPdf = await PDFDocument.create();

    // Copy pages from the first PDF
    let copiedPages1;
    if (pdfDoc1) {
      copiedPages1 = await mergedPdf.copyPages(
        pdfDoc1,
        pdfDoc1.getPageIndices()
      );
      copiedPages1.forEach((page) => mergedPdf.addPage(page));
    }

    // Copy pages from the second PDF
    const copiedPages2 = await mergedPdf.copyPages(
      pdfDoc2,
      pdfDoc2.getPageIndices()
    );
    copiedPages2.forEach((page) => mergedPdf.addPage(page));

    // Serialize the document to bytes
    const mergedPdfBytes = await mergedPdf.save();

    // Convert bytes to base64
    return uint8ArrayToBase64(new Uint8Array(mergedPdfBytes));
  } catch (error) {
    console.error("Error merging PDFs or converting images:", error);
    return "";
  }
};

export const maskEmail = (email: string) => {
  // Validate email format using regular expression
  if (!emailRegex.test(email)) {
    return email;
  }

  // Split the email into local and domain parts
  const [localPart, domain] = email.split("@");

  // Mask the local part, keeping only the first and last characters visible
  const maskedLocalPart: string =
    localPart.length > 2
      ? `${localPart[0]}${"*".repeat(localPart.length - 2)}${
          localPart[localPart.length - 1]
        }`
      : localPart; // Handle short local parts without masking

  // Return the masked email
  return `${maskedLocalPart}@${domain}`;
};

export const base64ToTiffImageFormat = (
  base64: string
): Promise<HTMLImageElement> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = `data:image/tiff;base64,${base64}`;
    img.onload = () => resolve(img);
  });
};

// Function to generate the JWT
export const generateJWT = async (payload: UserPayload) => {
  const jwt = await new SignJWT(payload)
    .setProtectedHeader({ alg: "HS256", typ: "JWT" })
    .sign(secretKey);
  return jwt;
};

export const generateJWTChatBot = async (payload: UserPayloadChatBot) => {
  const jwt = await new SignJWT(payload)
    .setProtectedHeader({ alg: "HS256" })
    .sign(chatbotsecretKey);
  return jwt;
};

export const convertTiffToPng = (image: HTMLImageElement): Promise<string> => {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (ctx) {
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    } else {
      throw new Error("Failed to get canvas context");
    }
  });
};

export const getLogoutInfo = (
  tokenDetails: T_GenerateTokenRes,
  userDetails: T_UserProfile & T_CustomerLobDetails
) => {
  return {
    token: "" + tokenDetails?.external.access_token,
    supportingData: {
      mobile: `${
        !_.isEmpty(userDetails?.mobileNumber) ? userDetails?.mobileNumber : ""
      }`,
      destinationLobId: "25",
      sourceLobId: Cs_App_Lob_Id,
      functionalityCode: "LO",
      isOnBoarding: userDetails?.IS_USER_REGISTERED ? "Yes" : "No",
      isExtensionRequired: "No",
      pan: `${!_.isEmpty(userDetails?.pan) ? userDetails?.pan : ""}`,
      dob: `${
        !_.isEmpty(userDetails?.dob)
          ? userDetails?.dob?.replaceAll("/", "-")
          : ""
      }`,
      email: `${!_.isEmpty(userDetails?.emailId) ? userDetails?.emailId : ""}`,
    },
  };
};

export const goToSuperAppInfo = (
  tokenDetails: T_GenerateTokenRes,
  userDetails: T_UserProfile & T_CustomerLobDetails,
  funCode?: string
) => {
  const ciiExists = userDetails?.customerAndLobDetails.some((r) => r.CII);
  return {
    token: "" + tokenDetails?.external.access_token,
    supportingData: {
      mobile: `${
        !_.isEmpty(userDetails?.mobileNumber) ? userDetails?.mobileNumber : ""
      }`,
      destinationLobId: "25",
      sourceLobId: Cs_App_Lob_Id,
      functionalityCode: funCode || staticPurchaseCtaFunctionalityCode, //staticPurchaseCtaFunctionalityCode is added due to absence of dynamic quickActions menu in cug, once added remove this static one,
      isOnBoarding: userDetails.IS_USER_REGISTERED ? "Yes" : "No",
      isExtensionRequired: "No",
      pan: `${!_.isEmpty(userDetails?.pan) ? userDetails?.pan : ""}`,
      dob: `${
        !_.isEmpty(userDetails?.dob)
          ? userDetails?.dob?.replaceAll("/", "-")
          : ""
      }`,
      email: `${!_.isEmpty(userDetails?.emailId) ? userDetails?.emailId : ""}`,
    },
  };
};

export const getDecryptedSearchParamsValue = (searchParamsString: string) => {
  let decodedUrl = decodeURIComponent(searchParamsString);
  let decryptedSearchParams = decryptString(
    decodedUrl,
    "1234567891234567",
    "2619AD481DFBB08C"
  );
  const pairs = decryptedSearchParams.split("&");
  let tempData: any = {};
  pairs.forEach((pair) => {
    const [key, value] = pair.split("=");
    if (key) {
      tempData[key] = value;
    }
  });
  return tempData;
};

export const updateNPSSessionStorage = (value?: string, mode?: string) => {
  const initialValue = CsSessionStorageUtils.get("NPS_SESSION_MANAGEMENT");
  // const jsonValue = initialValue ? JSON.parse(initialValue) : [];
  const jsonValue: NPSItem[] = initialValue ? JSON.parse(initialValue) : [];

  // const isIncluded = jsonValue.includes(value, mode);
  jsonValue.push({ value, mode });

  CsSessionStorageUtils.set(
    "NPS_SESSION_MANAGEMENT",
    JSON.stringify(jsonValue)
  );

  return true;
};

export const checkNPSSessionStorage = (value?: string, mode?: string) => {
  const initialValue = CsSessionStorageUtils.get("NPS_SESSION_MANAGEMENT");
  // const jsonValue = initialValue ? JSON.parse(initialValue) : [];
  const jsonValue: NPSItem[] = initialValue ? JSON.parse(initialValue) : [];
  console.log(jsonValue);

  // const isIncluded = jsonValue.includes(value, mode);

  const isIncluded = jsonValue.filter(
    (item) => item.value === value && item.mode === mode
  );
  if (!isEmpty(isIncluded)) {
    return false;
  } else {
    return true;
  }
};

/**
 * Get mobile operating system
 * @returns
 */
export const getMobileOperatingSystem = () => {
  let userAgent = navigator.userAgent || (window as any)?.opera;

  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }
  if (/android/i.test(userAgent)) {
    return "Android";
  }
  if (/iPad|iPhone|iPod/.test(userAgent) || iOS()) {
    return "iOS";
  }
  return "unknown";
};

const iOS = () => {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod",
  ].includes(navigator.platform);
};

export const checkNativeAndroid = () => {
  return document.referrer.includes("android-app://") ? true : false;
};

export const checkNativeIOS = () => {
  return document.referrer.includes("ios-app://") ? true : false;
};

export const checkNativeApp = () => {
  let isNativeApp = false;
  const referrer = document.referrer;
  if (referrer.includes("android-app://") || referrer.includes("ios-app://")) {
    isNativeApp = true;
  }
  return isNativeApp;
};

export let publicKeyCredentialCreationOptions: CredentialCreationOptions = {
  publicKey: {
    challenge: new Uint8Array([117, 61, 252, 231, 191, 241]),
    rp: { name: "MVIAPP" },
    authenticatorSelection: {
      userVerification: "required",
    },
    user: {
      id: new Uint8Array(16),
      name: "Customer Servicing App",
      displayName: "CS App User",
    },
    pubKeyCredParams: [
      { type: "public-key", alg: -7 },
      { type: "public-key", alg: -8 },
      { type: "public-key", alg: -257 },
    ],
  },
};

export const publicKeyCredentialRequestOptions = (rawId: ArrayBuffer) => {
  const creds: CredentialRequestOptions = {
    publicKey: {
      challenge: new Uint8Array([117, 61, 252, 231, 191, 241]),
      allowCredentials: [{ type: "public-key", id: rawId }],
      rpId: window.location.host,
      userVerification: "required",
    },
  };
  return creds;
};

export const ab2str = (ab: ArrayBuffer) => {
  let binary = "";
  let bytes = new Uint8Array(ab);
  let len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

export const str2ab = (str: string) => {
  let binaryString = atob(str);
  let bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

// Function to generate a device ID
export const generateDeviceID = (): string => {
  const userAgent = navigator.userAgent;
  const screenResolution = `${window.screen.width}x${window.screen.height}`;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const language = navigator.language;

  const deviceInfo = `${userAgent}-${screenResolution}-${timezone}-${language}`;
  return CryptoJS.SHA256(deviceInfo).toString();
};

export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  let browserName: string, fullVersion: string | undefined;

  if (userAgent.indexOf("Firefox") > -1) {
    browserName = "Mozilla Firefox";
    const match = userAgent.match(/Firefox\/(\d+\.\d+)/);
    fullVersion = match ? match[1] : "Unknown";
  } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
    browserName = "Opera";
    const match = userAgent.match(/Opera|OPR\/(\d+\.\d+)/);
    fullVersion = match ? match[1] : "Unknown";
  } else if (userAgent.indexOf("Edg") > -1) {
    browserName = "Microsoft Edge";
    const match = userAgent.match(/Edg\/(\d+\.\d+)/);
    fullVersion = match ? match[1] : "Unknown";
  } else if (userAgent.indexOf("Chrome") > -1) {
    browserName = "Google Chrome";
    const match = userAgent.match(/Chrome\/(\d+\.\d+)/);
    fullVersion = match ? match[1] : "Unknown";
  } else if (
    userAgent.indexOf("Safari") > -1 &&
    userAgent.indexOf("Chrome") === -1
  ) {
    browserName = "Apple Safari";
    const match = userAgent.match(/Version\/(\d+\.\d+)/);
    fullVersion = match ? match[1] : "Unknown";
  } else if (userAgent.indexOf("MSIE") > -1 || !!document.DOCUMENT_NODE) {
    browserName = "Microsoft Internet Explorer";
    const match = userAgent.match(/MSIE (\d+\.\d+)/);
    fullVersion = match ? match[1] : "Unknown";
  } else {
    browserName = "Unknown";
    fullVersion = "Unknown";
  }

  return { browserName, fullVersion };
};

export class FaqApiAbortController {
  static AbortController: AbortController | undefined = undefined;
}
export const isBiometricSetUpCompleted = (
  mobileNumber: string,
  CS_USER_ID: string,
  bioInfo: T_BioInfo
) => {
  let isBioSetupDone = false;
  if (
    !_.isEmpty(bioInfo) &&
    bioInfo.mobile === mobileNumber &&
    bioInfo.csUserId === CS_USER_ID &&
    bioInfo.hasOwnProperty("biometricToken") &&
    !_.isEmpty(bioInfo.biometricToken)
  ) {
    isBioSetupDone = true;
  }
  return isBioSetupDone;
};

export const removePrefixSuffix = (name: string) => {
  return name
    .replace(/^((MR|MISS|MIS)\.?(\s+)?)|((\s+)?(MR|MISS|MIS)\.?)$/gi, "")
    .trim();
};

export const getFileExtension = (filename: string): string => {
  const parts = filename.split(".");
  if (parts.length > 1) {
    return parts[parts.length - 1].toUpperCase();
  }
  return "";
};
export const windowOpen = (url?: string, param?: string, feature?: string) => {
  if (getMobileOperatingSystem() === "iOS") {
    window.location.href = `${url}`;
  } else {
    window.open(url, param, feature);
  }
};

export const createOneServiceSubRequestBody = (
  masterData: T_FetchMasterData_Response | undefined,
  lob: string,
  customerLobDetails?: T_CustomerLobDetailObj | undefined
) => {
  const filteredCaseCreateData =
    masterData?.masterDetail?.case_create.filter(
      (item) => item.lobId === lob && item.masterKey === "case-subtype-code"
    ) || [];
  let oneServiceSubRequestBody: T_OneServiceSub_Request = {
    ciiNumber: customerLobDetails?.CII || "",
    caseSubtypeCode: filteredCaseCreateData[0].masterValue || "",
    isMultipleLOB: "N",
    isMultipleProductHolding: "false",
  };
  return oneServiceSubRequestBody;
};

export const getGTAEventScreenType = (path: string) => {
  const GTAEventScreen = [
    {
      path: R_SSRoutes.details_Portfolio,
      screen_type: "ss_servicing",
      screen_name: "stocks_and_securities_servicing_detail_screen",
    },
    {
      path: R_SSRoutes.details_Portfolio_MyDocuments,
      screen_type: "ss_servicing",
      screen_name:
        "stocks_and_securities_servicing_my_documents_option_select_screen",
    },
    {
      path: "R_SSRoutes.account_statement",
      screen_type: "ss_servicing",
      screen_name:
        "stocks_and_securities_servicing_statement_of_accounts_enter_details_screen",
    },
    {
      path: R_SSRoutes.account_statement,
      screen_type: "ss_servicing",
      screen_name:
        "stocks_and_securities_servicing_contract_note_enter_details_screen",
    },
    {
      path: R_SSRoutes.account_statement,
      screen_type: "ss_servicing",
      screen_name:
        "stocks_and_securities_servicing_contract_note_enter_details_screen",
    },
    {
      path: R_HLRoutes.home_loan_details,
      screen_type: "hfl_servicing",
      screen_name: "housing_finance_servicing_detail_screen",
    },
    {
      path: R_HLRoutes.account_statement,
      screen_type: "hfl_servicing",
      screen_name:
        "housing_finance_servicing_statements_of_account_option_select_screen",
    },
    {
      path: R_HLRoutes.interest_certificate,
      screen_type: "hfl_servicing",
      screen_name:
        "housing_finance_servicing_interest_certificate_option_select_screen",
    },
    {
      path: R_HLRoutes.change_address,
      screen_type: "hfl_servicing",
      screen_name:
        "housing_finance_servicing_change_address_option_select_screen",
    },
    {
      path: R_HLRoutes.home_loan_change_emi_date,
      screen_type: "hfl_servicing",
      screen_name:
        " housing_finance_servicing_change_emi_occupation_type_select_screen",
    },
    {
      path: R_HLRoutes.excess_emi_refund,
      screen_type: "hfl_servicing",
      screen_name: "housing_finance_servicing_excess_emi_refund_screen",
    },
    {
      path: R_HLRoutes.change_enach,
      screen_type: "hfl_servicing",
      screen_name:
        "housing_finance_servicing_register_/_change_e-nach_occupation_type_select_screen",
    },
    {
      path: R_HLRoutes.document_upload,
      screen_type: "hfl_servicing",
      screen_name:
        "housing_finance_servicing_register_/_change_e-nach_upload_document_screen",
    },
    {
      path: R_HLRoutes.disbursement_request,
      screen_type: "hfl_servicing",
      screen_name: "housing_finance_servicing_disbursement_form_detail_screen",
    },
    {
      path: R_MfRoutes.mutualFund_Details,
      screen_type: "mf_servicing",
      screen_name: "mutual_funds_servicing_detail_screen",
    },
    {
      path: R_LiRoutes.li_baseUrl,
      screen_type: "li_servicing",
      screen_name: "life_insurance_servicing_detail_screen",
    },
    {
      path: R_LiRoutes.details_PolicyNumber_TaxCertificate,
      screen_type: "li_servicing",
      screen_name:
        "life_insurance_servicing_tax_certificate_enter_details_screen",
    },
    {
      path: R_LiRoutes.addUpdate_nominee,
      screen_type: "li_servicing",
      screen_name: "life_insurance_servicing_nominee_success_screen",
    },
    {
      path: R_LiRoutes.details_PolicyNumber_PremiumReceipts,
      screen_type: "li_servicing",
      screen_name:
        "life_insurance_servicing_premium_receipts_enter_details_screen",
    },
    {
      path: R_LiRoutes.details_PolicyNumber_PolicyAccountStatement,
      screen_type: "li_servicing",
      screen_name:
        "life_insurance_servicing_policy_account_statement_enter_details_screen",
    },
    {
      path: R_LiRoutes.details_PolicyNumber_UpdatePAN,
      screen_type: "li_servicing",
      screen_name: "life_insurance_servicing_detail_screen",
    },
    {
      path: R_LiRoutes.detail_PolicyNumber_AddUpdateBankAccount,
      screen_type: "li_servicing",
      screen_name: "life_insurance_servicing_add_new_account_screen",
    },
    {
      path: R_HiRoutes.hi_baseUrl,
      screen_type: "hi_servicing",
      screen_name: "health_insurance_servicing_detail_screen",
    },
    {
      path: R_HiRoutes.details_PolicyNumber_MedicalReports,
      screen_type: "hi_servicing",
      screen_name:
        "health_insurance_servicing_member_medical_reports_download_screen",
    },
    {
      path: R_HiRoutes.details_PolicyNumber_EditPolicy,
      screen_type: "hi_servicing",
      screen_name: "health_insurance_servicing_edit_policy_details_screen",
    },
  ];
  for (const screen of GTAEventScreen) {
    if (path.includes(screen.path)) {
      return screen;
    }
  }
  return {
    screen_type: "servicing_homescreen_dashboard",
    screen_name: "dashboard",
  };
};

export const getFinancialYearCount = (data: T_menu[], menuName: string) => {
  let flattenedData = data.flatMap((item) => [item, ...item.menuDetails]);
  const foundItem = flattenedData.find(
    (item) => item.menuName.toLowerCase() === menuName.toLowerCase()
  );
  return foundItem?.financialYearCount || "4";
};
/**
 * sample playstore/Appstore link: android=https://play.google.com/store/apps/details?id=com.adityabirlacapitaldigital.OneApp,ios=https://apps.apple.com/in/app/abcd-aditya-birla-capital/id6477909524?mt=8
 * @param links = android=PlayStoreLink,ios=AppStoreLink
 * @param osType = 'android|ios'
 * @returns https://play.google.com/store/apps/details?id=com.adityabirlacapitaldigital.OneApp
 */
export const getCMSLink = (links: string, osType: string) => {
  if (!links) {
    return "";
  }
  const isKeyValuePair = links.match(/^(android=|ios=|web=)/);
  if (!isKeyValuePair) {
    return links.trim();
  }
  const linksArray = links.split(",");
  const linkMap: Record<string, string> = linksArray.reduce((map, link) => {
    const [key, ...rest] = link.split("=");
    const value = rest.join("=");
    if (key && value) {
      map[key.trim()] = value.trim();
    }
    return map;
  }, {} as Record<string, string>);
  return linkMap[osType] || linksArray[0]?.split("=")[1]?.trim() || links;
};
const { format } = new Intl.NumberFormat("hi-In", {
  style: "currency",
  currency: "INR",
});
export const getRupeeFormat_HL = (val: string): string => {
  if (val === "") {
    return `₹0`;
  }
  const numVal = parseFloat(val);
  if (isNaN(numVal)) {
    throw new Error("Invalid number format");
  }
  // Format the number value to currency
  const formattedValue = format(numVal);

  // Split formatted value to remove decimal part and return
  return formattedValue.split(".")[0];
};

export const hlIndexFinder = (
  allSummaryData: T_SummaryData[],
  accountNumber: string | undefined
) => {
  if (!accountNumber) return -1;
  const lanNumber = accountNumber?.trim();
  return allSummaryData.findIndex(
    (item) => item.loan_info.rows[0].LOAN_ACCOUNT_NUMBER === lanNumber
  );
};

export const clearImgValueFromElement = (id: string) => {
  const inputElement = document.getElementById(id) as HTMLInputElement;
  if (inputElement) {
    inputElement.value = "";
  }
};

export const isCurrentFinancialYear = (financialYear: string): boolean => {
  const currentDate = new Date();

  // Get current year and month
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0 for January, so adding 1.

  // Check if we are in the first half of the year (April to September) or second half (October to March)
  const startYear = parseInt(financialYear.split("-")[0]);
  const endYear = parseInt(financialYear.split("-")[1]);

  // Financial year starts from April of startYear and ends in March of endYear
  if (
    (currentMonth >= 4 && currentYear === startYear) ||
    (currentMonth <= 3 && currentYear === endYear)
  ) {
    return true;
  }
  return false;
};

export const oneServiceRedirectionFun = (params: string = "") => {
  const operatingSystem = getMobileOperatingSystem();
  // Check for Android
  if (operatingSystem === "Android" || operatingSystem === "Windows Phone") {
    return windowOpen(
      ABC_SERVICE_PLAYSTORE_URL + "&referrer=" + params.replace("?", "&"),
      "_self"
    ); // Replace with actual Android app URL
  }
  // Check for iOS
  else if (operatingSystem === "iOS") {
    return windowOpen(ABC_SERVICE_APPSTORE_URL + params, "_self"); // Replace with actual iOS app URL
  }
  // For Desktop/Laptop
  else {
    return windowOpen(REACT_APP_URL + params, "_self"); // Replace with the actual web portal login URL
  }
};

export const LobNameWithCode = (lobCode: string) => {
  const mapping: { [key: string]: string } = {
    ABSLI: "Life Insurance",
    ABHI: "Health Insurance",
    ABHFL: "Home Loan",
    ABSLAMC: "Mutual Fund",
    ABML: "Stocks",
    ABFL: "Personal Loan",
  };
  return mapping[lobCode] || "General App";
};

export const getSuperAppRedirectionData = (
  csAppSlice: T_CsAppSliceState,
  userDetails: (T_UserProfile & T_GetCustomerLobDetailsRes) | undefined,
  funCode: string = ""
) => {
  return {
    token: "" + csAppSlice?.tokenDetails?.external.access_token,
    supportingData: {
      mobile: `${
        !isEmpty(userDetails?.mobileNumber) ? userDetails?.mobileNumber : ""
      }`,
      destinationLobId: Abcd_Super_App_Lob_Id,
      sourceLobId: Cs_App_Lob_Id,
      functionalityCode: funCode,
      isOnBoarding: userDetails?.IS_USER_REGISTERED ? "Yes" : "No",
      isExtensionRequired: "No",
      pan: `${!isEmpty(userDetails?.pan) ? userDetails?.pan : ""}`,
      dob: `${
        !isEmpty(userDetails?.dob) ? userDetails?.dob?.replaceAll("/", "-") : ""
      }`,
      email: `${!isEmpty(userDetails?.emailId) ? userDetails?.emailId : ""}`,
    },
  };
};

export function extractUniqueLoanAccountNumbers(results: any[]): string[] {
  // Extract and flatten all loan account numbers from the results
  let transformedResult: string[] = results
    .flatMap((item: any) => {
      if (item.data?.payload?.LOAN_ACCOUNT_NUMBER) {
        return item.data.payload.LOAN_ACCOUNT_NUMBER.map((val: string) => val);
      }
      return [];
    })
    .filter((val: string) => val !== undefined && val !== null && val !== "");

  // Remove duplicates using a Set
  const set: Set<string> = new Set(transformedResult);

  // Return the unique loan account numbers
  return Array.from(set);
}

export const buildSSOPayload = (
  csAppSlice: any,
  ssoSlice: any,
  redirectionUrl: string,
  functionalityCode: string,
  destinationLobId: string,
  ciiNo: string | undefined,
  panNo: string | undefined,
  name: string | undefined,
  dob: string | undefined,
  lobClientId: string | undefined,
  apiPassword?: string,
  userId?: string
) => {
  const payload: any = {
    triggerGenerateSSO_Old: (ssoSlice as TriggerGenerateSSO_OLD)
      .triggerGenerateSSO_Old
      ? !(ssoSlice as TriggerGenerateSSO_OLD).triggerGenerateSSO_Old
      : true,
    redirectionUrl: redirectionUrl,
    ciiNo: ciiNo,
    functionality: functionalityCode,
    mobileNo: csAppSlice.userDetails?.mobileNumber || "7978522720",
    lobClientId: ssoSlice.lobClientId,
    channel: "WEB",
    sourceLobId: Cs_App_Lob_Id,
    destinationLobId: destinationLobId,
    callbackUrl: `${REACT_APP_URL}/login`,
    appVersion: "1",
    panNumber: panNo,
    customerFullName: name,
    customerDob: dob,
    emailId: csAppSlice.userDetails?.emailId || "abc@pwc.com",
    osVersion: "Windows",
    imei: "1231312",
    deviceId: csAppSlice.userAgent?.deviceId || "131312",
    userAgent: navigator.userAgent,
    clientIpAddress: "",
    udp: "",
    udp2: "",
    udp3: "",
    udp4: "",
    udp5: "",
    udp6: "",
    udp7: "",
    udp8: "",
    udp9: "",
    udp10: "",
    showLoading: true,
  };

  // Conditionally add `userId` and `apiPassword` if they are provided
  if (userId) {
    payload.userId = userId;
  }

  if (apiPassword) {
    payload.apiPassword = apiPassword;
  } else {
    payload.apiPassword = ""; // Empty string or default value if not provided
  }
  return payload;
};

export function copyToClipboard(generatedSrNumber: any, setShowTick: any) {
  let timeout: any;

  navigator.clipboard.writeText(`${generatedSrNumber}`).then(() => {
    setShowTick(true);
    timeout = setTimeout(() => {
      setShowTick(false);
    }, 3000);
  });

  return () => clearTimeout(timeout);
}
export const findMenuByName = (
  menuArray: T_menu[],
  menuName: string
): T_menu | null => {
  for (let item of menuArray) {
    // Check if the current item's menuName matches the search
    if (item.menuName?.toLowerCase() === menuName?.toLowerCase()) {
      return item;
    }
    // If not, and if it has menuDetails, search recursively
    if (item.menuDetails && item.menuDetails?.length > 0) {
      const result = findMenuByName(item.menuDetails, menuName);
      if (result) {
        return result;
      }
    }
  }
  // Return null if no match is found
  return null;
};

//OSP 1232 helper functions start here
export const getSdfcCommonRequestPayload = (
  commonDetails: Object,
  existingDetails: Object,
  updatedDetails: Object
) => {
  let commonDetailsList = {
    source: sfdcSourceName,
    issueTypeCode: "",
    intimationType: sfdcIntimationType,
    policy: "",
    priority: sfdcPriority,
    channel: sfdcChannel,
    clientCode: "",
    businessUnit: sfdcBusinessUnit,
    onCreateCloseSR: "",
    customerMemberText: "",
    comments: "",
  };

  let existingDetailsList = {
    existingEmailId: "",
    existingDob: "",
    existingGender: "",
    existingPanCardNumber: "",
    existingFirstName: "",
    existingMiddleName: "",
    existingLastName: "",
    oldAddress: "",
    existingPrimaryNumber: "",
    existingAlternateNumber: "",
    existingNomineeContactNumber: "",
    existingNomineeRelationship: "",
  };

  let updatedDetailsList = {
    primaryEmailId: "",
    dob: "",
    gender: "",
    panCard: "",
    firstName: "",
    middleName: "",
    lastName: "",
    newAddressLine1: "",
    newAddressLine2: "",
    newAddressLine3: "",
    state: "",
    country: "",
    city: "",
    pinCode: "",
    primaryContactNumber: "",
    alternateContactNumber: "",
    newNomineeName: "",
    newNomineeRelationship: "",
    newNomineeContactNumber: "",
    createAttachment: [
      {
        pathOnClient: "",
        title: "",
        versionData: "",
      },
    ],
  };
  let v1 = Object.assign(commonDetailsList, commonDetails);
  let v2 = Object.assign(existingDetailsList, existingDetails);
  let v3 = Object.assign(updatedDetailsList, updatedDetails);
  let finalRequest = Object.assign(v1, v2, v3);
  return finalRequest;
};

export const fetchIssueTypeCodeFromMaster = (
  data: T_MasterData_DetailObjOption[],
  masterKey: string
): string | null => {
  const match = data.find(
    (item) => item.masterKey.toLowerCase() === masterKey.toLowerCase()
  );
  return match ? match.masterValue : "";
};

export const mapName = (name: string, existing: boolean) => {
  const nameParts = name.trim().split(/\s+/);
  const mappedName = existing
    ? { existingFirstName: "", existingMiddleName: "", existingLastName: "" }
    : { firstName: "", middleName: "", lastName: "" };

  if (nameParts.length > 0) {
    mappedName[existing ? "existingFirstName" : "firstName"] = nameParts[0];
  }
  if (nameParts.length > 1) {
    mappedName[existing ? "existingLastName" : "lastName"] =
      nameParts.length === 2 ? nameParts[1] : nameParts.slice(2).join(" ");
  }
  if (nameParts.length > 2) {
    mappedName[existing ? "existingMiddleName" : "middleName"] = nameParts[1];
  }

  return mappedName;
};
//OSP 1232 helper functions end here

//OSP-2212 helpers start here

export const getMfStatementData = (
  quickActionData: T_menu[] | undefined,
  subMenuName: string,
  functionalityKey: string
) => {
  const menuData = quickActionData
    ?.find(
      (item) => item?.menuName.toLowerCase() === myStatementsText.toLowerCase()
    )
    ?.menuDetails?.find(
      (menuItem) =>
        menuItem?.menuName?.toLowerCase() === subMenuName.toLowerCase()
    );

  const globalTypeData = J_FunctionalityCode?.find(
    (item) => item.name === functionalityKey
  );

  return {
    menuData,
    globalTypeData,
  };
};
//OSP-2212 helpers end here

export const getValidEmailFromCustomerAndLobDetails = (
  customerAndLobDetails: T_CustomerLobDetailObj[] | undefined
) => {
  let email: string | undefined = "";
  const primaryCustomerHoldings = customerAndLobDetails?.filter(
    (item) => item.PRIMARY_SECONDARY_USER === "primary"
  );
  if (isEmpty(primaryCustomerHoldings)) {
    return email;
  }
  let activeHoldings =
    primaryCustomerHoldings?.filter(
      (item) =>
        item.STATUS === ActiveStatusText &&
        isValidateEmail(item.EMAIL?.trim() || "")
    ) || [];
  if (activeHoldings?.length > 0) {
    email = activeHoldings?.[0]?.EMAIL || "";
  } else {
    email = isValidateEmail(primaryCustomerHoldings?.[0]?.EMAIL || "")
      ? primaryCustomerHoldings?.[0]?.EMAIL
      : "";
  }
  return email;
};

export const handlePermissionMessage = (
  event: CustomEvent,
  permissionType: string,
  setPermissionState: (permissionAllowed: boolean) => void,
  callPermissionApi: (
    permissionType: string,
    permissionAllowed: boolean
  ) => void
) => {
  console.log(`${permissionType} Permission Message: `, event.detail);

  // Convert permission string to boolean
  const permissionInfo = event.detail === "true" ? true : false;
  console.log(`${permissionType} Permission: `, permissionInfo);

  // Update the permission state
  setPermissionState(permissionInfo);

  // Call the permission API with permission type and state
  callPermissionApi(permissionType, permissionInfo);
};

interface ReduxValues {
  beneficiarySummary: Array<{
    date?: string;
    name?: string;
    amount?: any;
  }>;
  balanceAmount?: any;
  otherData: {
    customerId?: string;
    accountNumber?: string;
    firstName?: string;
    lastName?: string;
    mobile?: string;
    emailId?: string;
  };
}

export const processSummaryData = (
  allSummaryData: T_SummaryData[], // Typed as an array of T_SummaryData
  accountNumber: string | null, // accountNumber is a string or null
  setReduxValues: (values: ReduxValues) => void // setReduxValues expects a ReduxValues object
) => {
  if (allSummaryData.length > 0 && accountNumber !== null) {
    const idx = hlIndexFinder(allSummaryData, accountNumber);
    const summaryData = allSummaryData[Number(idx)];

    // Prepare the data to be set in Redux
    const beneficiarySummary = summaryData?.Disbursement_History?.rows.map(
      (data: any) => ({
        date: data?.DISBRUSMENT_DATE,
        name: data?.BENIFICIARY_NAME,
        amount: data?.AMOUNT,
      })
    );

    const balanceAmount =
      summaryData?.Disbursement_sUMMARY?.rows?.[0]?.BALANCE_REMAINING;

    const otherData = {
      customerId: summaryData?.account_detail?.rows[0]?.CUSTOMER_NO,
      accountNumber: summaryData?.Benificiary_Details?.rows[0]?.LOAN_ACCOUNT_NO,
      firstName: summaryData?.account_detail?.rows[0]?.FNAME,
      lastName: summaryData?.account_detail?.rows[0]?.LNAME,
      mobile: summaryData?.borrower_detail?.rows[0]?.MOBILE,
      emailId: summaryData?.borrower_detail?.rows[0]?.E_MAIL,
    };

    // Set the Redux values
    setReduxValues({
      beneficiarySummary,
      balanceAmount,
      otherData,
    });
  }
};

//OSP-2033 helpers start here

export const removeSurname = (fullName?: string) => {
  const prefixes = ["mr", "mrs", "ms", "dr", "smt"];
  const words = fullName?.trim().split(/\s+/);

  if (
    words &&
    words.length > 1 &&
    prefixes.includes(words[0].replace(/\./g, "").toLowerCase())
  ) {
    words.shift(); // remove prefix
  }

  return words?.join(" ");
};

export const extractNameParts = (
  fullName?: string
): { firstName: string; lastName: string } => {
  if (!fullName || fullName.trim() === "") {
    return { firstName: "", lastName: "" };
  }

  const ignoreTitles = [
    "mr",
    "mrs",
    "ms",
    "dr",
    "smt",
    "mr.",
    "mrs.",
    "ms.",
    "dr.",
    "smt.",
  ];
  const nameParts = fullName.trim().split(/\s+/);

  const filteredParts = nameParts.filter(
    (word) => !ignoreTitles.includes(word.toLowerCase())
  );

  const [firstName, ...rest] = filteredParts;
  const lastName = rest.join(" ");

  return {
    firstName: firstName || "",
    lastName: lastName || "",
  };
};

export const isMinor = (dob: string | null): boolean => {
  return dayjs().diff(dayjs(dob, "YYYY-MM-DD"), "year") < 18;
};

//OSP-2033 helpers end here

type WorkflowInfo = {
  borrowerDetails: any; // You can replace `any` with a more specific type if available
  loanInfo: any; // Same for this field
  accountDetail: any; // Same here
};

export const updateReduxValues = (
  allSummaryData: T_SummaryData[],
  accountNumber: string,
  setReduxValues: React.Dispatch<React.SetStateAction<WorkflowInfo>>
) => {
  if (allSummaryData.length > 0 && accountNumber !== "") {
    const idx = hlIndexFinder(allSummaryData, accountNumber);
    const summaryData = allSummaryData[Number(idx)];

    setReduxValues({
      borrowerDetails: summaryData?.borrower_detail?.rows[0] || [],
      loanInfo: summaryData?.loan_info?.rows[0] || [],
      accountDetail: summaryData?.account_detail?.rows[0] || [],
    });
  }
};

export const getModuleNameFromPath = (
  currentPath: string
): string | undefined => {
  const matchedBasePath = Object.keys(pathToModuleName).find((key) =>
    currentPath.startsWith(key)
  );

  return matchedBasePath
    ? pathToModuleName[matchedBasePath as ModuleNameKey]
    : undefined;
};

export const getDefaultMarqueeText = (data: T_CmsIntegrationVariables[]) => {
  return (
    data.find(
      (f) => f.attributes.isEnable && f.attributes.key === "Default Marquee"
    )?.attributes.text || "Search for Insurance policy details"
  );
};

export const handleClevertapCTAClickforEditIcon = (
  text: string,
  formfieldtitle: string,
  formfieldvalue: string,
  triggerCleverTapEventProps: string,
  screenNameValue: string
) => {
  triggerCleverTapEvent(triggerCleverTapEventProps, {
    ScreenType: SCREEN_TYPE.HIScreenType,
    ScreenName: screenNameValue,
    isPrevPageNameRequired: true,
    ctaText: text,
    FormFieldTitle: formfieldtitle,
    OptionSelected: formfieldvalue,
  });
};

export const getCmsConfigPopularServices = (
  data: T_CmsIntegrationVariables[]
) => {
  return data.filter(
    (f) =>
      f.attributes.isEnable &&
      f.attributes.pageReference === "Search - Popular services"
  );
};

export const getCmsExplorePlans = (data: T_CmsIntegrationVariables[]) => {
  return data.filter(
    (f) =>
      f.attributes.isEnable &&
      f.attributes.pageReference === "Search Explore Plans - Popular services"
  );
};

export const getPortfolioData = (data: T_StockDashboardDetails[]) => {
  const portfolioValue = data
    .map((item) => item.MarketValue)
    .reduce((sum, stock) => sum + parseFloat(stock), 0);

  const investedAmount = data
    .map((item) => item.InvestedCost)
    .reduce((sum, stock) => sum + parseFloat(stock), 0);

  const LastUpdatedDate = data
    .map((item) => item.tradedate)
    .reduce((maxObject, currentObject) => {
      const maxDate = maxObject ? parseDate(maxObject) : null;
      const currentDate = parseDate(currentObject);
      if (!maxDate || currentDate.isAfter(maxDate)) {
        return currentObject;
      } else {
        return maxObject;
      }
    });

  const gainLoss = data
    .map((item) => item.UnrealisedGainLoss)
    .reduce((sum, stock) => sum + parseFloat(stock), 0);

  const changeValue =
    investedAmount !== 0
      ? ((portfolioValue - investedAmount) / investedAmount) * 100
      : 0;
  return {
    portfolioValue,
    investedAmount,
    LastUpdatedDate,
    gainLoss,
    changeValue,
  };
};

export const getLobShortFormToSearch = (data: T_CustomerLobDetailObj[]) => {
  const lobsToSearch: string[] = [];
  const lobs = data
    ?.filter((f) => f.PRIMARY_SECONDARY_USER !== "secondary")
    ?.map((m) => m.LOB);
  if (lobs?.includes(LiLobCode)) {
    lobsToSearch.push("LI");
  }
  if (lobs?.includes(HiLobCode)) {
    lobsToSearch.push("HI");
  }
  if (lobs?.includes(MfLobCode)) {
    lobsToSearch.push("MF");
  }
  if (lobs?.includes(StockLobCode)) {
    lobsToSearch.push("SS");
  }
  if (lobs?.includes(HlLobCode)) {
    lobsToSearch.push("HL");
  }
  if (lobs?.includes(PersonalLoansLobCode)) {
    lobsToSearch.push("FL");
  }
  return lobsToSearch.join("|");
};

export const getValidNameFromCustomerAndLobDetails = (
  enteredDob: Dayjs | null,
  enteredPan: string,
  customerRecords: T_CustomerLobDetailObj[] = []
): string | null => {
  if (customerRecords.length === 0) {
    return "";
  }

  if (customerRecords.length === 1) {
    return customerRecords[0].NAME;
  }

  const checkPreference = (record: T_CustomerLobDetailObj): number => {
    const dobMatch =
      dayjs(record.DOB).format("YYYY-MM-DD") ===
      enteredDob?.format("YYYY-MM-DD");
    const panMatch = record.PAN?.toLowerCase() === enteredPan?.toLowerCase();
    const activeFlag = record.STATUS === "ACTIVE";

    if (dobMatch && panMatch && activeFlag) {
      return 1;
    } else if (dobMatch && !panMatch && activeFlag) {
      return 2;
    } else if (!dobMatch && panMatch && activeFlag) {
      return 3;
    } else if (dobMatch && panMatch && !activeFlag) {
      return 4;
    } else if (!dobMatch && panMatch && !activeFlag) {
      return 5;
    } else if (dobMatch && !panMatch && !activeFlag) {
      return 6;
    } else {
      return 7; // NTB if all are mismatched or if there is no match at all
    }
  };

  let highestPreferenceRecord = customerRecords[0];
  let highestPreferenceScore = checkPreference(customerRecords[0]);

  for (let i = 1; i < customerRecords.length; i++) {
    const record = customerRecords[i];
    const preferenceScore = checkPreference(record);
    if (preferenceScore < highestPreferenceScore) {
      highestPreferenceRecord = record;
      highestPreferenceScore = preferenceScore;
    }
  }

  return highestPreferenceRecord.NAME;
};

export const getCmsConfigMarquee = (
  cmsData: T_CmsIntegrationVariables[],
  activeTab: string
) => {
  const marqueeArr = cmsData.filter(
    (f) => f.attributes.isEnable && f.attributes.key === "Marquee"
  );
  return marqueeArr.filter((f) => {
    const tempData =
      activeTab === DashboardTabKeys.Insurance
        ? [LiDestinationLobId, HiDestinationLobId].includes(f.attributes.lobId)
        : activeTab === DashboardTabKeys.Investment
        ? [SsDestinationLobId, MfDestinationLobId].includes(f.attributes.lobId)
        : activeTab === DashboardTabKeys.Loans
        ? [LoansDestinationLobId, HomeLoansDestinationLobId].includes(
            f.attributes.lobId
          )
        : false;
    return f.attributes.isEnable && f.attributes.key === "Marquee" && tempData;
  });
};

type LOBCode =
  | typeof LiLobCode
  | typeof HiLobCode
  | typeof MfLobCode
  | typeof StockLobCode
  | typeof HlLobCode
  | typeof PersonalLoansLobCode;

const lobMappings: Record<LOBCode, string> = {
  [LiLobCode]: "Life Insurance",
  [HiLobCode]: "Health Insurance",
  [MfLobCode]: "Mutual Funds",
  [StockLobCode]: "Stocks & Securities",
  [HlLobCode]: "Home Loans",
  [PersonalLoansLobCode]: "Personal Loans",
};

export const getLobsToSearch = (
  userDetails: (T_UserProfile & T_GetCustomerLobDetailsRes) | undefined
) => {
  const lobs =
    userDetails?.customerAndLobDetails
      ?.filter((f) => f.PRIMARY_SECONDARY_USER === "primary")
      ?.map((m) => m.LOB) || [];

  return lobs
    .filter((lob): lob is LOBCode => lob in lobMappings) // Type Guard to avoid TS errors
    .map((lob) => lobMappings[lob]);
};
